export default "__VITE_ASSET__d1395900__"